import React from 'react';

import HeaderFunctional from './components/header-functional';

const Header = ({ title, showAccessLevel, hideAddAffiliate }) => {
	return <HeaderFunctional title={title} showAccessLevel={showAccessLevel} hideAddAffiliate={hideAddAffiliate} />;
};

export default Header;
